import { Injectable } from '@angular/core';
import { NavigationStart, NavigationEnd, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class NavigationLoaderService {

  // loading = signal(false);
  constructor(private spinner: NgxSpinnerService, private router: Router) {

    this.router.events.subscribe((event => {
      if (event instanceof NavigationStart) {
        // this.loading.set(true);
        this.spinner.show();
      }
      if (event instanceof NavigationEnd) {
        // this.loading.set(false);
        this.spinner.hide();
      }
    }))


  }


}
